export default "__VITE_ASSET__Bxn6kNab__"